import { ReactNode } from 'react';
import { ArrowRightIcon } from '../../../Icons/ArrowRightIcon';
import { Button, IButtonProps } from '../../Buttons/Button';
import { ControlLikeVariant } from '../../variants';

interface IProps extends Omit<IButtonProps, 'size'> {
  variant: ControlLikeVariant;
  children?: ReactNode;
}

export const ForwardButton = (props: IProps) => {
  const { children, ...rest } = props;
  return (
    <Button aria-label="Forward" {...rest}>
      <ArrowRightIcon />
      {children}
    </Button>
  );
};
